import { Injectable, inject } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable, Subject } from 'rxjs';
import { VigiMenuService } from '../service/vigi-menu.service';
import { InitService } from '@infodata-group/inf-commons';

@Injectable({
  providedIn: 'root',
})
export class MenuGuard {
  private menuService = inject(VigiMenuService);
  private router = inject(Router);
  private initService = inject(InitService);


  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    if (this.menuService.isLoaded) {
      return this.hasAccess(state);
    }

    const emitter = new Subject<boolean>();
    this.menuService.loadMenu$().subscribe(isLoaded => {
      if (isLoaded) {
        emitter.next(this.hasAccess(state));
      } else {
        this.router.navigateByUrl('not-found/601').then();
        emitter.next(false);
      }
    });
    return emitter;
  }

  hasAccess(state): boolean {
    if (this.menuService.isAllowed(state.url) || state.url.includes('error')) {
      return true;
    }
    this.router.navigateByUrl('error/403');
    return false;
  }
}
